export default __webpack_public_path__ + "static/media/ycLogo.9b414859.png";